import React from 'react';
import InsertOnEnterPlugin from "./InsertOnEnterPlugin";
import FigureNode from "./FigureNode";
import {VideoNode, VideoButton} from "./video";
import {LinkNode, LinkButton, UnlinkButton} from "./link";
import {VariableNode, VariableButton} from "./variable";
import {BlockquoteNode, BlockquoteButton} from "./blockquote";
import {HeaderNode, HeaderEdit} from "./headers";
import {ListNode, ListEdit} from "./lists";
import {EmailTemplateButton} from "./EmailTemplate";
import Button from "../../Button";
import classNames from 'classnames';

const BoldMark = ({children}) => (<b>{children}</b>);
const isBold = (value) => value.marks.size + "" === "1" && value.marks.find((mark) => mark.type + "" === 'bold');
const BoldButton = (props) => <Button disabled={props.disabled} icon="bold" color={isBold(props.value) ? "primary" : "default"} tooltip="Félkövér" onClick={(e) => { e && e.preventDefault(); props.onClick('bold'); }}/>;

const ItalicMark = ({children}) => (<em>{children}</em>);
const isItalic = (value) => value.marks.size + "" === "1" && value.marks.find((mark) => mark.type + "" === 'italic');
const ItalicButton = (props) => <Button disabled={props.disabled} icon="italic" color={isItalic(props.value) ? "primary" : "default"} tooltip="Dölt" onClick={(e) =>  { e && e.preventDefault(); props.onClick('italic'); }} />;

const UnderlineMark = ({children}) => (<u>{children}</u>);
const isUnderline = (value) => value.marks.size + "" === "1" && value.marks.find((mark) => mark.type + "" === 'underline');
const UnderlineButton = (props) => <Button disabled={props.disabled} icon="underline" color={isUnderline(props.value) ? "primary" : "default"} tooltip="Aláhúzott" onClick={(e) =>  { e && e.preventDefault(); props.onClick('underline'); }} />;

const StrikelineMark = ({children}) => (<s>{children}</s>);
const isStrikeline = (value) => value.marks.size + "" === "1" && value.marks.find((mark) => mark.type + "" === 'strike');
const StrikelineButton = (props) => <Button disabled={props.disabled} icon="strike" color={isStrikeline(props.value) ? "primary" : "default"} tooltip="Áthúzott" onClick={(e) =>  { e && e.preventDefault(); props.onClick('strike'); }} />;

const parseStyles = styles => styles
    .split(';')
    .filter(style => style.split(':')[0] && style.split(':')[1])
    .map(style => [
        style.split(':')[0].trim().replace(/-./g, c => c.substr(1).toUpperCase()),
        style.split(':').slice(1).join(':').trim()
    ])
    .reduce((styleObj, style) => ({
        ...styleObj,
        [style[0]]: style[1],
    }), {});

export const formatPureAttributes = (attrs) => {
    attrs = attrs || {};
    if(attrs.class) {
        attrs.className = attrs.class;//.trim().split(/\s+/).join(" ");
        delete attrs.class;
    }
    if(attrs.cellpadding) {
        attrs.cellPadding = attrs.cellpadding;
        delete attrs.cellpadding;
    }
    if(attrs.cellspacing) {
        attrs.cellSpacing = attrs.cellspacing;
        delete attrs.cellspacing;
    }
    if(attrs.style && typeof attrs.style === "string") {
        attrs.style = parseStyles(attrs.style);
    }
    return attrs;
}

const CodeNode = (props) => {
    return (
        <pre {...formatPureAttributes(props.node.data.get('attributes'))}>
            <code>{props.children}</code>
        </pre>
    )
}

const ParagraphNode = (props) => {
    return (
        <p {...formatPureAttributes(props.node.data.get('attributes'))}>
            {props.children}
        </p>
    )
}

const BreakNode = (props) => {
    return <br/>;
}

const SpanNode = (props) => {
    return <span {...formatPureAttributes(props.node.data.get('attributes'))}>{props.children}</span>;
}

const EditorTag = (props, editorId = null, wrapperClass = null, wrapperId = null) => {
    return <div {...formatPureAttributes(props.node.data.get('attributes'))} className={classNames("slate-editor", editorId)}>
        <div className={classNames(wrapperClass)} id={wrapperId}>
            {props.children}
        </div>
    </div>;
}

const Wrapper = (props) => {
    return <div {...formatPureAttributes(props.node.data.get('attributes'))}>{props.children}</div>;
}

const Table = (props) => {
    return <table {...formatPureAttributes(props.node.data.get('attributes'))}>{props.children}</table>
}

const Tbody = (props) => {
    return <tbody {...formatPureAttributes(props.node.data.get('attributes'))}>{props.children}</tbody>
}

const Tr = (props) => {
    return <tr {...formatPureAttributes(props.node.data.get('attributes'))}>{props.children}</tr>
}

const Td = (props) => {
    return <td {...formatPureAttributes(props.node.data.get('attributes'))}>{props.children}</td>
}

const Center = (props) => {
    return <center {...formatPureAttributes(props.node.data.get('attributes'))}>{props.children}</center>
}

const Style = (props) => {
    // TODO http://cssinjs.org/react-jss?v=v8.6.1#theming
    const css = props.node.data.get('content');
    //return <style type="text/css" {...props.node.data.get('attributes')}>{css}</style>
    return <div {...formatPureAttributes(props.node.data.get('attributes'))} style={{display: "none"}}>{css}</div>
}

export {
    BoldMark,
    BoldButton,
    ItalicMark,
    ItalicButton,
    UnderlineMark,
    UnderlineButton,
    StrikelineMark,
    StrikelineButton,
    FigureNode,
    CodeNode,
    ParagraphNode,
    VideoButton,
    VideoNode,
    VariableNode,
    VariableButton,
    LinkNode,
    LinkButton,
    UnlinkButton,
    BlockquoteNode,
    BlockquoteButton,
    EmailTemplateButton,
    BreakNode,
    SpanNode,
    EditorTag,
    HeaderEdit,
    HeaderNode,
    ListEdit,
    ListNode,
    Wrapper,
    Table,
    Tbody,
    Tr,
    Td,
    Center,
    Style,
    InsertOnEnterPlugin
};